import $ from "jquery";

const scrollspy = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            window: ".js-scrollspy",
            class: ".js-scrollspy-content",
            navbarLink: ".js-scrollspy-nav",
        };

        if ($(el.window).length === 0) return;

        $(document).on("scroll", function () {
            const currentTop = $(this).scrollTop();
            const elems = $(el.class);
            // loop each element
            elems.each(function () {
                const elemTop = $(this).offset().top - 140;
                const elemBottom = elemTop + $(this).height();

                if (currentTop >= elemTop && currentTop <= elemBottom) {
                    const id = $(this).attr("id");
                    const navElem = $('a[href="#' + id + '"]');
                    navElem
                        .addClass("PrivaciPolicy__Body__Navs__List--Active")
                        .siblings()
                        .removeClass("PrivaciPolicy__Body__Navs__List--Active");
                }
            });
        });
    };
    init();
};

try {
    scrollspy();
} catch (error) {
    console.error("scrollspy", error);
}
